import {
    BankBranches,
    BankData,
    BankRoutingNumber,
    InsuranceProviderType,
} from '~/types'

function lowerCaseValueMapperSelect(items: string[]) {
    const result = items.map((item: string) => {
        return {
            name: item,
            value: item.toLowerCase(),
        }
    })

    return result
}

function lowerCaseValueMapperCombobox(items: string[]) {
    const result = items.map((item: string) => {
        return {
            label: item,
            value: item.toLowerCase(),
        }
    })

    return result
}

export const ReportingPartyTypes = [
    { value: 'agent', name: 'Agent' },
    { value: 'broker', name: 'Broker' },
    { value: 'custodian', name: 'Custodian' },
    { value: 'driver', name: 'Driver' },
    { value: 'policyholder', name: 'Policyholder' },
    { value: 'roadside assistance', name: 'Roadside Assistance' },
]

export const DriversLicenseTypes = [
    { value: 'permanent', name: 'Permanent' },
    { value: 'learnersPermit', name: 'Learners Permit' },
    { value: 'visitorsPermit', name: 'Visitors Permit' },
]

const jmInsuranceProviders = [
    { insurerName: 'BCIC - Head Office, Kingston', insurerType: 'direct' },
    { insurerName: 'BCIC - Cross Roads', insurerType: 'direct' },
    { insurerName: 'BCIC - New Kingston', insurerType: 'direct' },
    { insurerName: 'BCIC - Portmore', insurerType: 'direct' },
    { insurerName: 'BCIC - Ocho Rios', insurerType: 'direct' },
    { insurerName: 'BCIC - Mandeville', insurerType: 'direct' },
    { insurerName: 'BCIC - Montego Bay', insurerType: 'direct' },
    { insurerName: 'BCIC - Savanna-la-mar', insurerType: 'direct' },
    { insurerName: 'Alice Elizabeth Cohen', insurerType: 'agent' },
    { insurerName: 'Andrea Walker', insurerType: 'agent' },
    { insurerName: 'Angela McIntosh', insurerType: 'agent' },
    { insurerName: 'Audrey Ledgister', insurerType: 'agent' },
    { insurerName: 'Beverley Campbell-Small', insurerType: 'agent' },
    { insurerName: 'Blossom Viviene Anderson', insurerType: 'agent' },
    { insurerName: 'Carol Elizabeth Grant', insurerType: 'agent' },
    { insurerName: 'Cynthia D. Benjamin', insurerType: 'agent' },
    { insurerName: 'Danielle Robinson', insurerType: 'agent' },
    { insurerName: 'Dian Dennis', insurerType: 'agent' },
    { insurerName: 'Doreen Samuels', insurerType: 'agent' },
    { insurerName: 'Eugena Rebecca Gardner', insurerType: 'agent' },
    { insurerName: 'Francine Warren-Kidd', insurerType: 'agent' },
    { insurerName: 'Georgia Marie Robotham', insurerType: 'agent' },
    { insurerName: 'Gezel Morgan', insurerType: 'agent' },
    { insurerName: 'Glenda Miller', insurerType: 'agent' },
    { insurerName: 'Gleneta Joan Kenyon', insurerType: 'agent' },
    { insurerName: 'Jasmin Bogle', insurerType: 'agent' },
    { insurerName: 'Josette Doure', insurerType: 'agent' },
    { insurerName: 'Kamar Graham', insurerType: 'agent' },
    { insurerName: 'Karen Edwards', insurerType: 'agent' },
    { insurerName: 'Kayon Whyte-Daley', insurerType: 'agent' },
    { insurerName: 'Kerine Gayle', insurerType: 'agent' },
    { insurerName: 'Laffaine Farquharson-Reynolds', insurerType: 'agent' },
    { insurerName: 'Latoya Little-Yee', insurerType: 'agent' },
    { insurerName: 'Maiha Reid-Abrahams', insurerType: 'agent' },
    { insurerName: 'Marcia Barrett-Myrie', insurerType: 'agent' },
    { insurerName: 'Maxine Rhoden', insurerType: 'agent' },
    { insurerName: 'Nicole Gooden', insurerType: 'agent' },
    { insurerName: 'Norma Walcott', insurerType: 'agent' },
    { insurerName: "O'niel Goulbourne", insurerType: 'agent' },
    { insurerName: 'Patrice Willis', insurerType: 'agent' },
    { insurerName: 'Richard Wilson', insurerType: 'agent' },
    { insurerName: 'Semone Grant-Mohamed', insurerType: 'agent' },
    { insurerName: 'Sheila Kerline Powell', insurerType: 'agent' },
    { insurerName: 'Stephen Williamson', insurerType: 'agent' },
    { insurerName: 'Tashain Ximinies', insurerType: 'agent' },
    { insurerName: "T'John Ritchie", insurerType: 'agent' },
    { insurerName: 'William Nash', insurerType: 'agent' },
    { insurerName: 'Yonique Spaulding', insurerType: 'agent' },
    { insurerName: 'Allied Insurance Brokers Ltd', insurerType: 'broker' },
    { insurerName: 'Assurance Brokers Ja Ltd', insurerType: 'broker' },
    { insurerName: 'Axia Insurance Agency Ltd', insurerType: 'broker' },
    { insurerName: 'BCMG - Kingston', insurerType: 'broker' },
    { insurerName: 'BCMG - Montego Bay', insurerType: 'broker' },
    {
        insurerName: 'Caribbean Assurance Brokers Limited',
        insurerType: 'broker',
    },
    {
        insurerName:
            'Chancellor Insurance Agency Ltd - Grenada Crescent, Kingston',
        insurerType: 'broker',
    },
    {
        insurerName:
            'Chancellor Insurance Agency Ltd - Ocean Village Shopping Centre, St. Ann',
        insurerType: 'broker',
    },
    {
        insurerName:
            'Chancellor Insurance Agency Ltd - Catherine Hall Plaza, St. Catherine',
        insurerType: 'broker',
    },
    {
        insurerName: 'Covenant Insurance Brokers - Norwood Road, Kingston',
        insurerType: 'broker',
    },
    {
        insurerName:
            'Covenant Insurance Brokers - Winchester Business Centre, Kingston',
        insurerType: 'broker',
    },
    {
        insurerName: 'Covenant Insurance Brokers - Mandeville, Manchester',
        insurerType: 'broker',
    },
    {
        insurerName: 'Covenant Insurance Brokers - Harbour Street, Portland',
        insurerType: 'broker',
    },
    {
        insurerName: 'Covenant Insurance Brokers - Old Harbour St. Catherine',
        insurerType: 'broker',
    },
    {
        insurerName: 'Covenant Insurance Brokers - Black River, St. Elizabeth',
        insurerType: 'broker',
    },
    {
        insurerName: 'Covenant Insurance Brokers - May Pen, Clarendon',
        insurerType: 'broker',
    },
    {
        insurerName: 'Covenant Insurance Brokers - Santa Cruz, St. Thomas',
        insurerType: 'broker',
    },
    {
        insurerName:
            'Crichton Insurance Agency Ltd - Winchester Business Complex',
        insurerType: 'broker',
    },
    {
        insurerName: 'Desmond Mair Insurance Brokers Ltd',
        insurerType: 'broker',
    },
    { insurerName: 'Destiny Insurance Agency Ltd', insurerType: 'broker' },
    { insurerName: 'Exodus Insurance Brokers Ltd', insurerType: 'broker' },
    { insurerName: 'Firm Insurance Brokers Ltd', insurerType: 'broker' },
    { insurerName: 'Fraser Fontaine & Kong Limited', insurerType: 'broker' },
    {
        insurerName: 'Gallagher Insurance Brokers Ja Ltd',
        insurerType: 'broker',
    },
    { insurerName: 'Genesis', insurerType: 'broker' },
    { insurerName: 'IIBRe', insurerType: 'broker' },
    {
        insurerName:
            'Jamaica Citadel Insurance Brokers Ltd - Fort Street, Montego Bay, St. James',
        insurerType: 'broker',
    },
    {
        insurerName:
            'Jamaica Citadel Insurance Brokers Ltd - Hutchinson Plaza, Savanna-la-mar, Westmoreland',
        insurerType: 'broker',
    },
    {
        insurerName:
            'Jamaica Citadel Insurance Brokers Ltd - Uptown Shopping Centre, Mosley Drive, Lucea, Hanover',
        insurerType: 'broker',
    },
    {
        insurerName: 'Jamaica Cooperative Ins. Agency (NUCS)',
        insurerType: 'broker',
    },
    { insurerName: 'JMMB Insurance Brokers Ltd', insurerType: 'broker' },
    {
        insurerName: 'Marathon Ins Brokers Ltd - Trinidad Terrace, Kingston',
        insurerType: 'broker',
    },
    {
        insurerName:
            'Marathon Ins Brokers Ltd - Fairview Commercial Complex, Montego Bay St. James',
        insurerType: 'broker',
    },
    {
        insurerName:
            'Marathon Ins Brokers Ltd - Portmore Pines Plaza, Portmore, St. Catherine',
        insurerType: 'broker',
    },
    {
        insurerName:
            'Marathon Ins Brokers Ltd - HA Williams & Sons Plaza, Savanna-la-mar, Westmoreland',
        insurerType: 'broker',
    },
    {
        insurerName: 'Nationwide Insurance Agents & Consultants Ltd',
        insurerType: 'broker',
    },
    { insurerName: 'NPG Insurance Brokers Ltd', insurerType: 'broker' },
    {
        insurerName:
            'Orion Insurance Brokers Ltd - Winchester Business Centre, Kingston',
        insurerType: 'broker',
    },
    {
        insurerName:
            'Orion Insurance Brokers Ltd - Oasis Plaza, Spanish Town, St. Catherine',
        insurerType: 'broker',
    },
    { insurerName: 'Pinnacle Insurance Brokers', insurerType: 'broker' },
    { insurerName: 'Riviera Ins Agency Ltd', insurerType: 'broker' },
    {
        insurerName:
            'Solid Life & General Insurance Brokers Limited - Half-Way-Tree Road, Kingston',
        insurerType: 'broker',
    },
    {
        insurerName:
            'Solid Life & General Insurance Brokers Limited - King Street, Linstead, St. Catherine',
        insurerType: 'broker',
    },
    {
        insurerName:
            'Solid Life & General Insurance Brokers Limited - Tudor Avenue, Manchester',
        insurerType: 'broker',
    },
    {
        insurerName: 'Spectrum Insurance Brokers Limited',
        insurerType: 'broker',
    },
    { insurerName: 'TFS Insurance Brokers', insurerType: 'broker' },
    { insurerName: 'Victoria Mutual Building Society', insurerType: 'broker' },
]

const bbInsuranceProviders = [
    {
        insurerName: 'British Caribbean Insurance Company Limited',
        insurerType: 'direct',
    },
    { insurerName: 'Alicia L. P. Williams', insurerType: 'agent' },
    { insurerName: 'Mark Boxill', insurerType: 'agent' },
    { insurerName: 'Sharon Hoosner', insurerType: 'agent' },
    { insurerName: 'Andrea Small', insurerType: 'agent' },
    { insurerName: 'Kelly Phillips', insurerType: 'agent' },
    { insurerName: 'BB Insurance Inc.', insurerType: 'broker' },
    { insurerName: 'Capita Insurance Brokers', insurerType: 'broker' },
    {
        insurerName: 'Gallagher Insurance Brokers (Barbados) Ltd',
        insurerType: 'broker',
    },
    { insurerName: 'Field Insurance Broker Inc', insurerType: 'broker' },
    { insurerName: 'First Insurance Brokers', insurerType: 'broker' },
    { insurerName: 'IMPS Assurance Broker Ltd', insurerType: 'broker' },
    { insurerName: 'Insurance & General Services', insurerType: 'broker' },
    {
        insurerName: 'Insurance Brokers & Solutions Inc.',
        insurerType: 'broker',
    },
    { insurerName: 'Lynch Insurance Brokers Ltd', insurerType: 'broker' },
    { insurerName: 'Preferred Insurance Brokers Ltd', insurerType: 'broker' },
    {
        insurerName: 'Quality Insurance Brokers & Financial Services',
        insurerType: 'broker',
    },
    { insurerName: 'Sentry Insurance Brokers', insurerType: 'broker' },
    { insurerName: 'Shawn Hope Insurance Brokers', insurerType: 'broker' },
    { insurerName: 'Supreme Insurance Brokers Ltd', insurerType: 'broker' },
    { insurerName: 'Swift Insurance Brokers Ltd', insurerType: 'broker' },
    { insurerName: 'Tomlin Insurance Brokers', insurerType: 'broker' },
    {
        insurerName: 'Tradewinds International Insurance Brokers',
        insurerType: 'broker',
    },
    {
        insurerName: 'Ultimate Insurance and Financial Services',
        insurerType: 'broker',
    },
]

const jmThirdPartyInsuranceProviders = [
    {
        insurerName: 'British Caribbean Insurance Company Limited',
        insurerType: 'direct',
    },
    { insurerName: 'Allied Insurance Brokers Ltd', insurerType: 'broker' },
    { insurerName: 'Assurance Brokers Ja Ltd', insurerType: 'broker' },
    { insurerName: 'Axia Insurance Agency Ltd', insurerType: 'broker' },
    { insurerName: 'BCMG - Kingston', insurerType: 'broker' },
    { insurerName: 'BCMG - Montego Bay', insurerType: 'broker' },
    {
        insurerName: 'Caribbean Assurance Brokers Limited',
        insurerType: 'broker',
    },
    {
        insurerName:
            'Chancellor Insurance Agency Ltd - Grenada Crescent, Kingston',
        insurerType: 'broker',
    },
    {
        insurerName:
            'Chancellor Insurance Agency Ltd - Ocean Village Shopping Centre, St. Ann',
        insurerType: 'broker',
    },
    {
        insurerName:
            'Chancellor Insurance Agency Ltd - Catherine Hall Plaza, St. Catherine',
        insurerType: 'broker',
    },
    {
        insurerName: 'Covenant Insurance Brokers - Norwood Road, Kingston',
        insurerType: 'broker',
    },
    {
        insurerName:
            'Covenant Insurance Brokers - Winchester Business Centre, Kingston',
        insurerType: 'broker',
    },
    {
        insurerName: 'Covenant Insurance Brokers - Mandeville, Manchester',
        insurerType: 'broker',
    },
    {
        insurerName: 'Covenant Insurance Brokers - Harbour Street, Portland',
        insurerType: 'broker',
    },
    {
        insurerName: 'Covenant Insurance Brokers - Old Harbour St. Catherine',
        insurerType: 'broker',
    },
    {
        insurerName: 'Covenant Insurance Brokers - Black River, St. Elizabeth',
        insurerType: 'broker',
    },
    {
        insurerName: 'Covenant Insurance Brokers - May Pen, Clarendon',
        insurerType: 'broker',
    },
    {
        insurerName: 'Covenant Insurance Brokers - Santa Cruz, St. Thomas',
        insurerType: 'broker',
    },
    {
        insurerName:
            'Crichton Insurance Agency Ltd - Winchester Business Complex',
        insurerType: 'broker',
    },
    {
        insurerName: 'Desmond Mair Insurance Brokers Ltd',
        insurerType: 'broker',
    },
    { insurerName: 'Destiny Insurance Agency Ltd', insurerType: 'broker' },
    { insurerName: 'Exodus Insurance Brokers Ltd', insurerType: 'broker' },
    { insurerName: 'Firm Insurance Brokers Ltd', insurerType: 'broker' },
    { insurerName: 'Fraser Fontaine & Kong Limited', insurerType: 'broker' },
    {
        insurerName: 'Gallagher Insurance Brokers Ja Ltd',
        insurerType: 'broker',
    },
    { insurerName: 'Genesis Insurance Brokers Ltd', insurerType: 'broker' },
    { insurerName: 'IIBRe', insurerType: 'broker' },
    {
        insurerName:
            'Jamaica Citadel Insurance Brokers Ltd - Fort Street, Montego Bay, St. James',
        insurerType: 'broker',
    },
    {
        insurerName:
            'Jamaica Citadel Insurance Brokers Ltd - Hutchinson Plaza, Savanna-la-mar, Westmoreland',
        insurerType: 'broker',
    },
    {
        insurerName:
            'Jamaica Citadel Insurance Brokers Ltd - Uptown Shopping Centre, Mosley Drive, Lucea, Hanover',
        insurerType: 'broker',
    },
    {
        insurerName: 'Jamaica Cooperative Ins. Agency (NUCS)',
        insurerType: 'broker',
    },
    { insurerName: 'JMMB Insurance Brokers Ltd', insurerType: 'broker' },
    {
        insurerName: 'Marathon Ins Brokers Ltd - Trinidad Terrace, Kingston',
        insurerType: 'broker',
    },
    {
        insurerName:
            'Marathon Ins Brokers Ltd - Fairview Commercial Complex, Montego Bay St. James',
        insurerType: 'broker',
    },
    {
        insurerName:
            'Marathon Ins Brokers Ltd - Portmore Pines Plaza, Portmore, St. Catherine',
        insurerType: 'broker',
    },
    {
        insurerName:
            'Marathon Ins Brokers Ltd - HA Williams & Sons Plaza, Savanna-la-mar, Westmoreland',
        insurerType: 'broker',
    },
    {
        insurerName: 'Nationwide Insurance Agents & Consultants Ltd',
        insurerType: 'broker',
    },
    { insurerName: 'NPG Insurance Brokers Ltd', insurerType: 'broker' },
    {
        insurerName:
            'Orion Insurance Brokers Ltd - Winchester Business Centre, Kingston',
        insurerType: 'broker',
    },
    {
        insurerName:
            'Orion Insurance Brokers Ltd  - Oasis Plaza, Spanish Town, St. Catherine',
        insurerType: 'broker',
    },
    { insurerName: 'Pinnacle Insurance Brokers', insurerType: 'broker' },
    { insurerName: 'Riviera Ins Agency Ltd', insurerType: 'broker' },
    {
        insurerName:
            'Solid Life & General Insurance Brokers Limited - Half-Way-Tree Road, Kingston',
        insurerType: 'broker',
    },
    {
        insurerName:
            'Solid Life & General Insurance Brokers Limited - King Street, Linstead, St. Catherine',
        insurerType: 'broker',
    },
    {
        insurerName:
            'Solid Life & General Insurance Brokers Limited - Tudor Avenue, Manchester',
        insurerType: 'broker',
    },
    {
        insurerName: 'Spectrum Insurance Brokers Limited',
        insurerType: 'broker',
    },
    { insurerName: 'TFS Insurance Brokers', insurerType: 'broker' },
    { insurerName: 'Victoria Mutual Building Society', insurerType: 'broker' },
    {
        insurerName: 'Advantage General Insurance Company Limited (AGIC)',
        insurerType: 'insurance company',
    },
    { insurerName: 'Attorney General', insurerType: 'insurance company' },
    { insurerName: 'Auto Smart Insurance', insurerType: 'insurance company' },
    {
        insurerName:
            'CG United Insurance Ltd. (formerly Massy United Insurance)',
        insurerType: 'insurance company',
    },
    {
        insurerName: 'General Accident Insurance Company Jamaica Limited (GA)',
        insurerType: 'insurance company',
    },
    {
        insurerName: 'GK General Insurance Company Limited (GKI)',
        insurerType: 'insurance company',
    },
    {
        insurerName: 'Guardian General Insurance Jamaica Limited (GGJ)',
        insurerType: 'insurance company',
    },
    {
        insurerName: 'IronRock Insurance Company Limited',
        insurerType: 'insurance company',
    },
    {
        insurerName: 'JN General Insurance Company Limited (JNGI)',
        insurerType: 'insurance company',
    },
    {
        insurerName: 'Key Insurance Company Limited',
        insurerType: 'insurance company',
    },
    {
        insurerName: 'The Insurance Company of the West Indies Limited (ICWI)',
        insurerType: 'insurance company',
    },
    {
        insurerName: 'Jamaica North South Highway',
        insurerType: 'insurance company',
    },
]

const bbThirdPartyInsuranceProviders = [
    {
        insurerName: 'British Caribbean Insurance Company Limited',
        insurerType: 'direct',
    },
    { insurerName: 'BB Insurance Inc.', insurerType: 'broker' },
    { insurerName: 'Capita Insurance Brokers', insurerType: 'broker' },
    {
        insurerName: 'Gallagher Insurance Brokers (Barbados) Ltd',
        insurerType: 'broker',
    },
    { insurerName: 'Field Insurance Broker Inc', insurerType: 'broker' },
    { insurerName: 'First Insurance Brokers', insurerType: 'broker' },
    { insurerName: 'IMPS Assurance Broker Ltd', insurerType: 'broker' },
    { insurerName: 'Insurance & General Services', insurerType: 'broker' },
    {
        insurerName: 'Insurance Brokers & Solutions Inc.',
        insurerType: 'broker',
    },
    { insurerName: 'Lynch Insurance Brokers Ltd', insurerType: 'broker' },
    { insurerName: 'Preferred Insurance Brokers Ltd', insurerType: 'broker' },
    {
        insurerName: 'Quality Insurance Brokers & Financial Services',
        insurerType: 'broker',
    },
    { insurerName: 'Sentry Insurance Brokers', insurerType: 'broker' },
    { insurerName: 'Shawn Hope Insurance Brokers', insurerType: 'broker' },
    { insurerName: 'Supreme Insurance Brokers Ltd', insurerType: 'broker' },
    { insurerName: 'Swift Insurance Brokers Ltd', insurerType: 'broker' },
    { insurerName: 'Tomlin Insurance Brokers', insurerType: 'broker' },
    {
        insurerName: 'Tradewinds International Insurance Brokers',
        insurerType: 'broker',
    },
    {
        insurerName: 'Ultimate Insurance and Financial Services',
        insurerType: 'broker',
    },
    {
        insurerName: 'Beacon Insurance Company Ltd.',
        insurerType: 'insurance company',
    },
    {
        insurerName: 'Caribbean Alliance Insurance/BGI Insurances',
        insurerType: 'insurance company',
    },
    {
        insurerName: 'Consumers Guarantee Insurance Company Ltd.',
        insurerType: 'insurance company',
    },
    {
        insurerName: 'Co-operators General Insurance Company Ltd.',
        insurerType: 'insurance company',
    },
    { insurerName: 'Equity Insurance Ltd', insurerType: 'insurance company' },
    {
        insurerName: 'General Accident Insurance Company Ltd.',
        insurerType: 'insurance company',
    },
    {
        insurerName: 'Guardian General Insurance Ltd.',
        insurerType: 'insurance company',
    },
    {
        insurerName: 'Insurance Corporation of Barbados Ltd.',
        insurerType: 'insurance company',
    },
    { insurerName: 'CG United Insurance', insurerType: 'insurance company' },
    {
        insurerName: 'Sagicor General Insurance',
        insurerType: 'insurance company',
    },
    {
        insurerName: 'Trident Insurance Company',
        insurerType: 'insurance company',
    },
]

const insuranceProviderMapper = (
    insuranceProvider: InsuranceProviderType[]
) => {
    const mappedInsuranceProviders = insuranceProvider.map((provider) => {
        return {
            label: provider.insurerName,
            value: `${provider.insurerType.toLowerCase()}||${provider.insurerName.toLowerCase()}`,
        }
    })

    return mappedInsuranceProviders
}

export const bbInsuranceProviderTypes =
    insuranceProviderMapper(bbInsuranceProviders)
export const jmInsuranceProviderTypes =
    insuranceProviderMapper(jmInsuranceProviders)

export const bbThirdPartyInsuranceProviderTypes = insuranceProviderMapper(
    bbThirdPartyInsuranceProviders
)
export const jmThirdPartyInsuranceProviderTypes = insuranceProviderMapper(
    jmThirdPartyInsuranceProviders
)

export const settlementOptionTypes = [
    { value: 'cash', name: 'Cash Settlement (Electronic Funds Transfer)' },
    {
        value: 'repairs',
        name: 'Repairs - we pay the repairer directly once your vehicle is repaired to your satisfaction',
    },
    { value: 'notSure', name: 'Not Sure/Undecided' },
]

const jmCollisionFirePreferredRepairers = [
    'Ankara Limited',
    'ATL Automotive Ltd',
    'Auto Campus',
    'Auto Maintenance Ltd',
    'Cars & Commercial Ltd (KIG)',
    "Cecil's Auto Services Ltd",
    'Cozi Auto Repairs & Rental',
    'Continental Garage Limited',
    'Devon McFarlane - Auto Body Repair and Paint',
    "Errol's Auto",
    "Everett Fenton's Garage Ltd",
    'Executive Motors Ltd',
    'Fdelity Motors Ltd',
    'Finish Line Auto Repairs',
    'Guys Hill Auto Repairs',
    'H Dockery Auto Body',
    'In De Street Auto Ltd',
    'James Hudson / Dennis Walker',
    'Ken Clarke Trading Co. Ltd.',
    'Kingston Industrial Garage',
    'LED360 Powered by Smurf Limited',
    "Leroy's Auto Repairs",
    "Lewis's Auto Body Repairs & Services",
    "Lloyd's (Pops) Garage & Auto Sales",
    'Magna Motor Dealership Ltd',
    'McTech Auto',
    'Mo-Bay Service Centre Ltd',
    'Muffler Specialists Ltd',
    "Murray's Auto Repairs",
    'M & M Mechanical & Electrical Auto Service Ltd',
    "Neil's Auto Service",
    'Oswald Smith',
    'Ramdeen Auto Repairs',
    'Rich-Als Garage',
    'S and J Auto Spare & Repair Co Ltd',
    "Shield's Garage",
    'Silver Star Motors Ltd',
    "Stewart's Auto Sales Ltd",
    'STS Vehicle Limited',
    'Superior Parts Ltd',
    'Super Quick Lube',
    'Thwaites Auto Center',
    "Trev's Auto",
    'Toyota Jamaica Ltd',
    "Von's Motor & Co Ltd",
    "West A's Auto Parts Ltd",
    'Other',
]

const jmWindscreenPreferredRepairers = [
    'ATL Automotive Ltd',
    'Bird Glass & Installation',
    'BC & F Auto Glass',
    'Dr. Glass Ltd',
    "Jason's Auto Windshield Replacement",
    "Leroy's Auto Glass",
    'Magna Motor Dealership Ltd',
    'Prolific Glass Ltd',
    'Quantum Auto Glass',
    'Remedial Auto Glass',
    "Stewart's Auto Sales Ltd",
    'Toyota Jamaica Ltd',
    'Other',
]

const bbCollisionFirePreferredRepairers = [
    'Downes Garage',
    "Corbin's Garage",
    'NASSCO Ltd',
    'Simpson Motors',
    'Courtesy Garage',
    'CA Autobody Repairs',
    'Ansa Motors',
    'Platinum Motors',
    'Automotive Art (BMW)',
    'Other',
]

const bbWindscreenPreferredRepairers = ['Ansa Motors',"Corbin's Garage",'Courtesy Garage','Caribbean Autoglass','Inchcape', 'MB Auto City','NASSCO Ltd','Platinum Motors', 'Other']

export const jmCollisionFirePreferredRepairerTypes =
    lowerCaseValueMapperCombobox(jmCollisionFirePreferredRepairers)
export const jmWindscreenPreferredRepairerTypes = lowerCaseValueMapperCombobox(
    jmWindscreenPreferredRepairers
)

export const bbCollisionFirePreferredRepairerTypes =
    lowerCaseValueMapperCombobox(bbCollisionFirePreferredRepairers)
export const bbWindscreenPreferredRepairerTypes = lowerCaseValueMapperCombobox(
    bbWindscreenPreferredRepairers
)

export const bankAccountTypes = [
    { value: 'checking', name: 'Checking' },
    { value: 'savings', name: 'Savings' },
]

export const jmBankNameTypes = [
    { value: 'boj', name: 'Bank of Jamaica' },
    { value: 'scotiaBank', name: 'Bank of Nova Scotia' },
    { value: 'citi', name: 'CitiBank N.A' },
    { value: 'firstGlobal', name: 'First Global Bank' },
    { value: 'firstCaribbean', name: 'FirstCaribbean International Bank' },
    { value: 'jmmb', name: 'JMMB Bank' },
    { value: 'jn', name: 'Jamaica National (JN) Bank' },
    { value: 'ncb', name: 'National Commercial Bank' },
    { value: 'sagicor', name: 'Sagicor Bank Limited' },
    { value: 'vmbs', name: 'Victoria Mutual Building Society (VMBS)' },
]

const jmBankBranchData: BankData = {
    BOJ: [{ branch: 'Kingston (00000)', routingNumber: '0000099' }],
    JM_BNS: [
        { branch: 'Christiana (00125)', routingNumber: '00125002' },
        { branch: 'Sav-La-Mar (00265)', routingNumber: '00265002' },
        { branch: 'Falmouth (01305)', routingNumber: '01305002' },
        { branch: 'Private Banking (09225)', routingNumber: '09225002' },
        { branch: 'Montego Bay (10215)', routingNumber: '10215002' },
        { branch: 'University Of W.I (18465)', routingNumber: '18465002' },
        { branch: 'Browns Town (20115)', routingNumber: '20115002' },
        { branch: "St. Ann's Bay (20255)", routingNumber: '20255002' },
        { branch: 'Lucea (21345)', routingNumber: '21345002' },
        {
            branch: 'Constant Spring Financial Centre (21725)',
            routingNumber: '21725002',
        },
        { branch: 'Junction (22475)', routingNumber: '22475002' },
        { branch: 'King Street (30015)', routingNumber: '30015002' },
        { branch: 'May Pen (30205)', routingNumber: '30205002' },
        { branch: 'Sj Building Society (36525)', routingNumber: '36525002' },
        { branch: 'Ironshore (38745)', routingNumber: '38745002' },
        { branch: 'Black River (40105)', routingNumber: '40105002' },
        { branch: 'Old Harbour (41335)', routingNumber: '41335002' },
        { branch: 'Mandeville (50195)', routingNumber: '50195002' },
        { branch: 'Port Maria (50245)', routingNumber: '50245002' },
        { branch: 'New Kingston (50575)', routingNumber: '50575002' },
        { branch: 'Scotia Centre (50765)', routingNumber: '50765002' },
        { branch: 'Half Way Tree (60145)', routingNumber: '60145002' },
        { branch: 'Premier (61325)', routingNumber: '61325002' },
        { branch: 'Morant Bay (61655)', routingNumber: '61655002' },
        { branch: 'Linstead (70185)', routingNumber: '70185002' },
        { branch: 'Port Antonio (70235)', routingNumber: '70235002' },
        { branch: 'Cross Roads (80135)', routingNumber: '80135002' },
        { branch: 'Spanish Town (80275)', routingNumber: '80275002' },
        { branch: 'Santa Cruz (81315)', routingNumber: '81315002' },
        { branch: 'Oxford Road (81505)', routingNumber: '81505002' },
        { branch: 'Hagley Pk. Rd. (90175)', routingNumber: '90175002' },
        { branch: 'Ocho Rios (90225)', routingNumber: '90225002' },
        { branch: 'Liguanea (90365)', routingNumber: '90365002' },
        { branch: 'Fairview (90605)', routingNumber: '90605002' },
        { branch: 'Negril (92825)', routingNumber: '92825002' },
        { branch: 'Portmore (95505)', routingNumber: '95505002' },
    ],
    CBNA: [{ branch: 'Kingston (00001)', routingNumber: '00001026' }],
    FGB: [
        { branch: 'New Kingston (99075)', routingNumber: '99075075' },
        { branch: 'Montego Bay (99080)', routingNumber: '99080075' },
        { branch: 'Manor Park (99082)', routingNumber: '99082075' },
        { branch: 'Mandeville (99084)', routingNumber: '99084075' },
        { branch: 'Liguanea (99085)', routingNumber: '99085075' },
        { branch: 'Corporate (99087)', routingNumber: '99087075' },
        { branch: 'Duke & Harbour (99089)', routingNumber: '99089075' },
        { branch: 'Ocho Rios (99094)', routingNumber: '99094075' },
        { branch: 'Cross Roads (99095)', routingNumber: '99095075' },
        { branch: 'Santa Cruz (99096)', routingNumber: '99096075' },
        { branch: 'Portmore (99097)', routingNumber: '99097075' },
        { branch: 'Linstead (99098)', routingNumber: '99098075' },
        { branch: 'Hopewell (99099)', routingNumber: '99099075' },
        { branch: 'May Pen (99100)', routingNumber: '99100075' },
    ],
    JM_FCIB: [
        { branch: 'Processing Center (07406)', routingNumber: '07406010' },
        {
            branch: 'Commercial Clients Group (07426)',
            routingNumber: '07426010',
        },
        { branch: 'Corporate (07426)', routingNumber: '07426010' },
        { branch: 'Wealth Management (09004)', routingNumber: '09004010' },
        { branch: 'Manor Park (09076)', routingNumber: '09076010' },
        { branch: 'King Street (09156)', routingNumber: '09156010' },
        { branch: 'Port Antonio (09516)', routingNumber: '09516010' },
        { branch: 'Ocho Rios (09526)', routingNumber: '09526010' },
        { branch: 'Half Way Tree (09536)', routingNumber: '09536010' },
        { branch: 'Fairview (09546)', routingNumber: '09546010' },
        { branch: 'Montego Bay (09546)', routingNumber: '09546010' },
        { branch: 'May Pen (09596)', routingNumber: '09596010' },
        { branch: 'Santa Cruz (09597)', routingNumber: '09597010' },
        { branch: 'Twin Gates (09656)', routingNumber: '09656010' },
        { branch: 'New Kingston (09676)', routingNumber: '09676010' },
        { branch: 'Sav-La-Mar (09677)', routingNumber: '09677010' },
        { branch: 'Mandeville (09746)', routingNumber: '09746010' },
        { branch: 'Portmore (09747)', routingNumber: '09747010' },
        { branch: 'Liguanea (09748)', routingNumber: '09748010' },
        { branch: 'Head Office (09866)', routingNumber: '09866010' },
        { branch: 'Small Business Unit (27502)', routingNumber: '27502010' },
    ],
    JMMB: [
        { branch: 'Head Office (00002)', routingNumber: '00002062' },
        { branch: 'Kingston (00003)', routingNumber: '00003062' },
        { branch: 'Montego Bay (00004)', routingNumber: '00004062' },
        { branch: 'Ocho Rios (00024)', routingNumber: '00024062' },
        { branch: 'Haughton (00060)', routingNumber: '00060062' },
        { branch: 'Portmore (00061)', routingNumber: '00061062' },
        { branch: 'Mandeville (00064)', routingNumber: '00064062' },
        { branch: 'Fairview (00086)', routingNumber: '00086062' },
    ],
    JNB: [
        { branch: 'Head Office (00001)', routingNumber: '00001050' },
        {
            branch: 'Internal Processing Centre (00002)',
            routingNumber: '00002050',
        },
        { branch: 'Centralised Operations (00036)', routingNumber: '00036050' },
        { branch: 'Half Way Tree (00051)', routingNumber: '00051050' },
        { branch: 'New Kingston (00052)', routingNumber: '00052050' },
        { branch: 'Duke Street (00053)', routingNumber: '00053050' },
        { branch: 'Papine (00055)', routingNumber: '00055050' },
        {
            branch: 'Spanish Town Road (Tivoli) (00056)',
            routingNumber: '00056050',
        },
        { branch: 'Barbican (00057)', routingNumber: '00057050' },
        { branch: 'Whitehouse (00058)', routingNumber: '00058050' },
        { branch: 'Knutsford Blvd (00059)', routingNumber: '00059050' },
        { branch: 'Old Harbour (00060)', routingNumber: '00060050' },
        { branch: 'Highgate (00092)', routingNumber: '00092050' },
        { branch: 'Hwt Transport Centre (00093)', routingNumber: '00093050' },
        { branch: 'Uwi (00094)', routingNumber: '00094050' },
        { branch: 'Michi Super Centre (00095)', routingNumber: '00095050' },
        { branch: 'Portmore Pines (00120)', routingNumber: '00120050' },
        { branch: 'Spanish Town (00121)', routingNumber: '00121050' },
        { branch: 'Linstead (00122)', routingNumber: '00122050' },
        { branch: 'Premier (00148)', routingNumber: '00148050' },
        { branch: 'May Pen (00191)', routingNumber: '00191050' },
        { branch: 'Mandeville (00261)', routingNumber: '00261050' },
        { branch: 'Christiana (00262)', routingNumber: '00262050' },
        { branch: 'Santa Cruz (00331)', routingNumber: '00331050' },
        { branch: 'Junction (00332)', routingNumber: '00332050' },
        { branch: 'Savanna-La-Mar (00401)', routingNumber: '00401050' },
        { branch: 'Falmouth (00450)', routingNumber: '00450050' },
        { branch: 'Lucea (00471)', routingNumber: '00471050' },
        { branch: 'Montego Bay (00541)', routingNumber: '00541050' },
        { branch: 'Browns Town (00681)', routingNumber: '00681050' },
        { branch: "St Ann's Bay (00682)", routingNumber: '00682050' },
        { branch: 'Ocho Rios (00683)', routingNumber: '00683050' },
        { branch: 'Port Maria (00751)', routingNumber: '00751050' },
        { branch: 'Annotto Bay (00752)', routingNumber: '00752050' },
        { branch: 'Gayle (00753)', routingNumber: '00753050' },
        { branch: 'Port Antonio (00821)', routingNumber: '00821050' },
        { branch: 'Morant Bay (00891)', routingNumber: '00891050' },
        { branch: 'Catherine Hall (00999)', routingNumber: '00999050' },
    ],
    NCB: [
        { branch: 'Operations Centre (00001)', routingNumber: '00001077' },
        { branch: 'Card Centre - Issuing (00002)', routingNumber: '00002077' },
        {
            branch: 'Human Resources Department (00003)',
            routingNumber: '00003077',
        },
        {
            branch: 'Centralized Foreign Exchange (00004)',
            routingNumber: '00004077',
        },
        {
            branch: 'Card Centre - Acquiring (00005)',
            routingNumber: '00005077',
        },
        { branch: 'King Street (00006)', routingNumber: '00006077' },
        { branch: 'Network Operations (00007)', routingNumber: '00007077' },
        { branch: 'Transformation Unit (00008)', routingNumber: '00008077' },
        { branch: 'Duke and Barry St (00010)', routingNumber: '00010077' },
        { branch: 'Boulevard Super Centre (00013)', routingNumber: '00013077' },
        { branch: 'Windward Rd Agency (00016)', routingNumber: '00016077' },
        { branch: 'Hagley Park (00017)', routingNumber: '00017077' },
        { branch: 'Staff Training Centre (00018)', routingNumber: '00018077' },
        { branch: 'Harbour View (00020)', routingNumber: '00020077' },
        { branch: 'Oxford Place (00021)', routingNumber: '00021077' },
        { branch: 'Cross Roads (00023)', routingNumber: '00023077' },
        { branch: '30 Knutsford Blvd. (00024)', routingNumber: '00024077' },
        { branch: 'Yallahs (00025)', routingNumber: '00025077' },
        { branch: 'Private Banking (00026)', routingNumber: '00026077' },
        { branch: 'Private Banking (00029)', routingNumber: '00029077' },
        { branch: 'Half Way Tree (00030)', routingNumber: '00030077' },
        { branch: 'Boulevard Super Centre (00031)', routingNumber: '00031077' },
        { branch: 'Red Hills Road (00032)', routingNumber: '00032077' },
        { branch: 'Manor Park (00033)', routingNumber: '00033077' },
        {
            branch: '1-7 Knutsford Boulevard (00035)',
            routingNumber: '00035077',
        },
        { branch: 'Portmore (00036)', routingNumber: '00036077' },
        { branch: "Matilda's Corner (00037)", routingNumber: '00037077' },
        { branch: 'Newport West (00039)', routingNumber: '00039077' },
        { branch: 'University (00040)', routingNumber: '00040077' },
        { branch: 'Montego Bay (00043)', routingNumber: '00043077' },
        { branch: 'Falmouth (00044)', routingNumber: '00044077' },
        { branch: 'Gloucester & Kent (00046)', routingNumber: '00046077' },
        {
            branch: 'St Jago Shopping Centre (00047)',
            routingNumber: '00047077',
        },
        { branch: 'Mandeville Plaza (00049)', routingNumber: '00049077' },
        { branch: 'Manchester Rd Agency (00050)', routingNumber: '00050077' },
        {
            branch: 'Legal, Aml & Corp. Comp. Div. (00051)',
            routingNumber: '00051077',
        },
        { branch: "St Ann's Bay (00054)", routingNumber: '00054077' },
        { branch: 'Lionel Town Agency (00055)', routingNumber: '00055077' },
        { branch: 'May Pen (00056)', routingNumber: '00056077' },
        { branch: 'Chapelton (00057)', routingNumber: '00057077' },
        { branch: 'Ocho Rios (00058)', routingNumber: '00058077' },
        { branch: 'Negril (00060)', routingNumber: '00060077' },
        { branch: 'Savanna-La-Mar (00061)', routingNumber: '00061077' },
        { branch: 'Grange Hill Agency (00063)', routingNumber: '00063077' },
        { branch: 'Morant Bay (00064)', routingNumber: '00064077' },
        { branch: 'Black River (00067)', routingNumber: '00067077' },
        { branch: 'Linstead (00068)', routingNumber: '00068077' },
        { branch: "Brown's Town (00071)", routingNumber: '00071077' },
        { branch: 'Lucea (00075)', routingNumber: '00075077' },
        { branch: 'Annotto Bay (00078)', routingNumber: '00078077' },
        { branch: 'Port Maria (00081)', routingNumber: '00081077' },
        { branch: 'Spauldings Agency (00082)', routingNumber: '00082077' },
        { branch: 'Christiana (00085)', routingNumber: '00085077' },
        { branch: 'Old Harbour (00087)', routingNumber: '00087077' },
        { branch: 'Junction (00088)', routingNumber: '00088077' },
        { branch: 'Santa Cruz (00089)', routingNumber: '00089077' },
        { branch: 'Head Office (00090)', routingNumber: '00090077' },
        { branch: 'Banking Operations (00200)', routingNumber: '00200077' },
        { branch: 'Centralised Operations (00201)', routingNumber: '00201077' },
        { branch: 'Specialised Operations (00202)', routingNumber: '00202077' },
        { branch: 'Direct Banking Unit (00204)', routingNumber: '00204077' },
        { branch: 'NCB Cayman (GCAYM)', routingNumber: 'GCAYMNCBCI' },
    ],
    JM_SBL: [
        { branch: 'Duke and Tower Street (01001)', routingNumber: '01001081' },
        { branch: 'Half Way Tree (01002)', routingNumber: '01002081' },
        { branch: 'Montego Bay (01003)', routingNumber: '01003081' },
        { branch: 'Mandeville (01004)', routingNumber: '01004081' },
        { branch: 'Black River (01006)', routingNumber: '01006081' },
        { branch: 'Savanna La Mar (01008)', routingNumber: '01008081' },
        { branch: 'May Pen (01011)', routingNumber: '01011081' },
        { branch: 'Portmore (01014)', routingNumber: '01014081' },
        { branch: 'Ocho Rios (01015)', routingNumber: '01015081' },
        { branch: 'Up-Park Camp (01020)', routingNumber: '01020081' },
        { branch: 'Knutsford Boulevard (01021)', routingNumber: '01021081' },
        { branch: 'Hope Road (01024)', routingNumber: '01024081' },
        { branch: 'Fairview (01025)', routingNumber: '01025081' },
        { branch: 'Dominica Drive (01034)', routingNumber: '01034081' },
        { branch: 'Liguanea (01050)', routingNumber: '01050081' },
        { branch: 'Manor Park (01051)', routingNumber: '01051081' },
        { branch: 'Tropical Plaza (01063)', routingNumber: '01063081' },
        {
            branch: 'Corporate Banking Centre (01085)',
            routingNumber: '01085081',
        },
    ],
    JM_VMBS: [
        { branch: 'Half Way Tree', routingNumber: '000010511' },
        { branch: 'Spanish Town', routingNumber: '000020514' },
        { branch: 'May Pen', routingNumber: '000030517' },
        { branch: 'Liguanea', routingNumber: '000040510' },
        { branch: 'Montego Bay', routingNumber: '000050513' },
        { branch: 'Ocho Rios', routingNumber: '000060516' },
        { branch: 'Mandeville', routingNumber: '000070519' },
        { branch: 'Falmouth', routingNumber: '000080512' },
        { branch: 'Linstead', routingNumber: '000090515' },
        { branch: 'Duke Street', routingNumber: '000100515' },
        { branch: 'New Kingston', routingNumber: '000110518' },
        { branch: 'Savanna-la-Mar', routingNumber: '000120511' },
        { branch: 'Santa Cruz', routingNumber: '000140517' },
        { branch: 'Portmore Mall', routingNumber: '000150510' },
        { branch: 'UTECH', routingNumber: '000240514' },
        { branch: 'Fairview', routingNumber: '000280516' },
    ],
}

export const jmBankBranchTypes: BankBranches = {}

export const jmRoutingNumbers: BankRoutingNumber = {}

const bankBranchMapper = (
    bankData: BankData,
    bankBranches: BankBranches,
    routingNumbers: BankRoutingNumber
) => {
    for (const [bank, branchData] of Object.entries(bankData)) {
        bankBranches[bank] = branchData.map((item) => {
            const branchNumberMatch = item.branch.match(/\((\d+)\)/)
            const branchNumber = branchNumberMatch
                ? branchNumberMatch[1]
                : item.branch

            const value = `${bank}||${branchNumber}`
            routingNumbers[value] = item.routingNumber

            return { label: item.branch, value }
        })
    }
}

bankBranchMapper(jmBankBranchData, jmBankBranchTypes, jmRoutingNumbers)

export const bbBankNameTypes = [
    { value: 'scotiaBank', name: 'Bank of Nova Scotia' },
    { value: 'bob', name: 'Central Bank of Barbados' },
    { value: 'firstCitizens', name: 'First Citizens Bank Barbados Limited' },
    { value: 'firstCaribbean', name: 'CIBC FirstCaribbean International Bank' },
    {
        value: 'firstCaribbeanMortgage',
        name: 'FirstCaribbean Mortgage Finance',
    },
    { value: 'rbc', name: 'RBC Royal Bank of Canada' },
    {
        value: 'rbcFinancial',
        name: 'RBC Royal Bank of Canada Financial Corporation',
    },
    { value: 'republicBank', name: 'Republic Bank Ltd' },
    { value: 'sagicor', name: 'Sagicor Bank Limited' },
]

const bbBankBranchData: BankData = {
    CBB: [{ branch: 'Bridgetown (00000)', routingNumber: '00000001' }],
    BNS: [
        { branch: 'Broad Street (40055)', routingNumber: '40055002' },
        { branch: 'Haggatt Hall (66555)', routingNumber: '66555002' },
        { branch: 'Rockley (70565)', routingNumber: '70565002' },
        { branch: 'Warrens (36285)', routingNumber: '36285002' },
    ],
    FCBBL: [
        { branch: 'Rendezvous (00003)', routingNumber: '00003009' },
        { branch: 'Sargeant Village (00004)', routingNumber: '00004009' },
        { branch: 'Worthing (00007)', routingNumber: '00007009' },
        { branch: 'Welches (00008)', routingNumber: '00008009' },
        { branch: 'Coverley (00009)', routingNumber: '00009009' },
        { branch: 'Wildey (00001)', routingNumber: '00005009' },
        { branch: 'Bridgetown (00001)', routingNumber: '00001009' },
        { branch: 'Collymore Rock (00002)', routingNumber: '00002009' },
    ],
    BB_CIBC: [
        { branch: 'Broad Street (09606)', routingNumber: '09606010' },
        { branch: 'Sheraton Mall (09586)', routingNumber: '00958710' },
        { branch: 'Speightstown (09636)', routingNumber: '00963710' },
        { branch: 'Holetown (09646)', routingNumber: '00964710' },
        { branch: 'Wildey (09127)', routingNumber: '00912810' },
        { branch: 'Warrens (09326)', routingNumber: '00909326' },
        { branch: 'Rendezvous (09616)', routingNumber: '00909616' },
    ],
    FCMF: [
        { branch: 'Rendezvous (09616)', routingNumber: '00961710' },
        { branch: 'Warrens (09326)', routingNumber: '09326010' },
    ],
    RRBC: [
        { branch: 'Broad Street (09435)', routingNumber: '09435003' },
        { branch: 'Collymore Rock (09785)', routingNumber: '09785003' },
        { branch: 'Hastings (09545)', routingNumber: '09545003' },
        { branch: 'Six Roads (00004)', routingNumber: '00004003' },
        { branch: 'Speightstown (09565)', routingNumber: '09565003' },
        { branch: 'St Lawrence (05605)', routingNumber: '05605003' },
        { branch: 'Sunset Crest (09425)', routingNumber: '09425003' },
    ],
    RRBCFC: [{ branch: 'Bridgetown (06465)', routingNumber: '06465003' }],
    RBL: [
        { branch: 'Airport (00004)', routingNumber: '00004006' },
        { branch: 'Broad Street (00002)', routingNumber: '00002006' },
        { branch: 'Holetown (00017)', routingNumber: '00017006' },
        { branch: 'Speightstown (00006)', routingNumber: '00006006' },
        { branch: 'Six Roads (00009)', routingNumber: '00009006' },
        { branch: 'Warrens (00010)', routingNumber: '00010006' },
        { branch: 'Wildey (00005)', routingNumber: '00005006' },
        { branch: 'Worthing (00014)', routingNumber: '00014006' },
    ],
    SBL: [{ branch: 'Worthing (00000)', routingNumber: '00000013' }],
}

export const bbBankBranchTypes: BankBranches = {}

export const bbRoutingNumbers: BankRoutingNumber = {}

bankBranchMapper(bbBankBranchData, bbBankBranchTypes, bbRoutingNumbers)

const pointOfImpact = [
    'Front',
    'Left Front',
    'Right Front',
    'Right Front Quarter Panel',
    'Left Front Quarter Panel',
    'Right Front Door',
    'Left Front Door',
    'Rear',
    'Left Rear',
    'Right Rear',
    'Left Rear Quarter Panel',
    'Right Rear Quarter Panel',
    'Left Rear Door',
    'Right Rear Door',
    'Hood',
    'Roof',
    'Trunk',
    'None',
    'Other',
]

export const pointOfImpactTypes = lowerCaseValueMapperSelect(pointOfImpact)

const currentYear = new Date().getFullYear()
const carYears = []

for (let year = currentYear; year >= currentYear - 100; year--) {
    carYears.push({ value: year.toString(), name: year.toString() })
}

export const years = carYears
export const getBankBranches = (
    bankName: string,
    branchNames: { label: string; value: string }[]
): { label: string; value: string }[] => {
    return branchNames?.filter((item) => item.value.startsWith(bankName))
}

export const getBankRoutingNumberJM = (
    bankName: string,
    branchName: string,
    branchNames: { label: string; value: string }[]
) => {
    const branches = jmBankBranchData[bankName]
    if (!branches) return undefined

    const bankBranches = getBankBranches(bankName, branchNames)
    const bankBranch = bankBranches.find((item) => item.value == branchName)
    if (!bankBranch?.label) return undefined

    const item = branches.find((item) =>
        item.branch.startsWith(bankBranch.label)
    )
    return item?.routingNumber
}

export const getBankRoutingNumberBB = (
    bankName: string,
    branchName: string,
    branchNames: { label: string; value: string }[]
) => {
    const branches = bbBankBranchData[bankName]
    if (!branches) return undefined

    const bankBranches = getBankBranches(bankName, branchNames)
    const bankBranch = bankBranches.find((item) => item.value == branchName)
    if (!bankBranch?.label) return undefined

    const item = branches.find((item) =>
        item.branch.startsWith(bankBranch.label)
    )
    return item?.routingNumber
}
